import { useEffect, useRef } from 'react';
import { Box, CircularProgress } from '@mui/joy';

/**
 * Невидимый «маяк» внизу списка. Когда попадает в область видимости
 * (с запасом rootMargin), вызывает onLoadMore — автоподгрузка без кнопок.
 */
function Sentinel({ onLoadMore, hasMore, loading }) {
    const ref = useRef(null);

    useEffect(() => {
        if (!hasMore) return;
        const el = ref.current;
        if (!el) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0]?.isIntersecting) onLoadMore?.();
            },
            { rootMargin: '400px' }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, [hasMore, onLoadMore]);

    if (!hasMore && !loading) return null;

    return (
        <Box ref={ref} sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            {loading && <CircularProgress size="sm" />}
        </Box>
    );
}

export default Sentinel;
